"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/client.ts
var client_exports = {};
__export(client_exports, {
  WHOOP_AUTH_EXPIRY: () => WHOOP_AUTH_EXPIRY,
  WHOOP_AUTH_TOKEN: () => WHOOP_AUTH_TOKEN,
  WHOOP_AUTH_USER: () => WHOOP_AUTH_USER,
  WHOOP_ENCODED_LEGACY_IOS_COOKIE: () => WHOOP_ENCODED_LEGACY_IOS_COOKIE,
  WHOOP_LEGACY_IOS_COOKIE: () => WHOOP_LEGACY_IOS_COOKIE,
  WHOOP_LEGACY_IOS_EXPIRY: () => WHOOP_LEGACY_IOS_EXPIRY,
  WHOOP_REFRESH_TOKEN: () => WHOOP_REFRESH_TOKEN,
  createClientAuth: () => createAuth
});
module.exports = __toCommonJS(client_exports);

// ../services/generated/auth-service/core/ApiError.ts
var ApiError = class extends Error {
  url;
  status;
  statusText;
  body;
  request;
  constructor(request2, response, message) {
    super(message);
    this.name = "ApiError";
    this.url = response.url;
    this.status = response.status;
    this.statusText = response.statusText;
    this.body = response.body;
    this.request = request2;
  }
};

// ../services/generated/auth-service/core/CancelablePromise.ts
var CancelError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "CancelError";
  }
  get isCancelled() {
    return true;
  }
};
var CancelablePromise = class {
  #isResolved;
  #isRejected;
  #isCancelled;
  #cancelHandlers;
  #promise;
  #resolve;
  #reject;
  constructor(executor) {
    this.#isResolved = false;
    this.#isRejected = false;
    this.#isCancelled = false;
    this.#cancelHandlers = [];
    this.#promise = new Promise((resolve2, reject) => {
      this.#resolve = resolve2;
      this.#reject = reject;
      const onResolve = (value) => {
        if (this.#isResolved || this.#isRejected || this.#isCancelled) {
          return;
        }
        this.#isResolved = true;
        this.#resolve?.(value);
      };
      const onReject = (reason) => {
        if (this.#isResolved || this.#isRejected || this.#isCancelled) {
          return;
        }
        this.#isRejected = true;
        this.#reject?.(reason);
      };
      const onCancel = (cancelHandler) => {
        if (this.#isResolved || this.#isRejected || this.#isCancelled) {
          return;
        }
        this.#cancelHandlers.push(cancelHandler);
      };
      Object.defineProperty(onCancel, "isResolved", {
        get: () => this.#isResolved
      });
      Object.defineProperty(onCancel, "isRejected", {
        get: () => this.#isRejected
      });
      Object.defineProperty(onCancel, "isCancelled", {
        get: () => this.#isCancelled
      });
      return executor(onResolve, onReject, onCancel);
    });
  }
  get [Symbol.toStringTag]() {
    return "Cancellable Promise";
  }
  then(onFulfilled, onRejected) {
    return this.#promise.then(onFulfilled, onRejected);
  }
  catch(onRejected) {
    return this.#promise.catch(onRejected);
  }
  finally(onFinally) {
    return this.#promise.finally(onFinally);
  }
  cancel() {
    if (this.#isResolved || this.#isRejected || this.#isCancelled) {
      return;
    }
    this.#isCancelled = true;
    if (this.#cancelHandlers.length) {
      try {
        for (const cancelHandler of this.#cancelHandlers) {
          cancelHandler();
        }
      } catch (error) {
        console.warn("Cancellation threw an error", error);
        return;
      }
    }
    this.#cancelHandlers.length = 0;
    this.#reject?.(new CancelError("Request aborted"));
  }
  get isCancelled() {
    return this.#isCancelled;
  }
};

// ../services/generated/auth-service/core/OpenAPI.ts
var OpenAPI = {
  BASE: "https://api-internal.prod.whoop.com/auth-service",
  VERSION: "",
  WITH_CREDENTIALS: false,
  CREDENTIALS: "include",
  TOKEN: void 0,
  USERNAME: void 0,
  PASSWORD: void 0,
  HEADERS: void 0,
  ENCODE_PATH: void 0
};

// ../services/generated/auth-service/core/request.ts
var isDefined = (value) => {
  return value !== void 0 && value !== null;
};
var isString = (value) => {
  return typeof value === "string";
};
var isStringWithValue = (value) => {
  return isString(value) && value !== "";
};
var isBlob = (value) => {
  return typeof value === "object" && typeof value.type === "string" && typeof value.stream === "function" && typeof value.arrayBuffer === "function" && typeof value.constructor === "function" && typeof value.constructor.name === "string" && /^(Blob|File)$/.test(value.constructor.name) && /^(Blob|File)$/.test(value[Symbol.toStringTag]);
};
var isFormData = (value) => {
  return value instanceof FormData;
};
var base64 = (str) => {
  try {
    return btoa(str);
  } catch (err) {
    return Buffer.from(str).toString("base64");
  }
};
var getQueryString = (params) => {
  const qs = [];
  const append = (key, value) => {
    qs.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
  };
  const process = (key, value) => {
    if (isDefined(value)) {
      if (Array.isArray(value)) {
        value.forEach((v) => {
          process(key, v);
        });
      } else if (typeof value === "object") {
        Object.entries(value).forEach(([k, v]) => {
          process(`${key}[${k}]`, v);
        });
      } else {
        append(key, value);
      }
    }
  };
  Object.entries(params).forEach(([key, value]) => {
    process(key, value);
  });
  if (qs.length > 0) {
    return `?${qs.join("&")}`;
  }
  return "";
};
var getUrl = (config, options) => {
  const encoder = config.ENCODE_PATH || encodeURI;
  const path = options.url.replace("{api-version}", config.VERSION).replace(/{(.*?)}/g, (substring, group) => {
    if (options.path?.hasOwnProperty(group)) {
      return encoder(String(options.path[group]));
    }
    return substring;
  });
  const url = `${config.BASE}${path}`;
  if (options.query) {
    return `${url}${getQueryString(options.query)}`;
  }
  return url;
};
var getFormData = (options) => {
  if (options.formData) {
    const formData = new FormData();
    const process = (key, value) => {
      if (isString(value) || isBlob(value)) {
        formData.append(key, value);
      } else {
        formData.append(key, JSON.stringify(value));
      }
    };
    Object.entries(options.formData).filter(([_, value]) => isDefined(value)).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((v) => process(key, v));
      } else {
        process(key, value);
      }
    });
    return formData;
  }
  return void 0;
};
var resolve = async (options, resolver) => {
  if (typeof resolver === "function") {
    return resolver(options);
  }
  return resolver;
};
var getHeaders = async (config, options) => {
  const token = await resolve(options, config.TOKEN);
  const username = await resolve(options, config.USERNAME);
  const password = await resolve(options, config.PASSWORD);
  const additionalHeaders = await resolve(options, config.HEADERS);
  const headers = Object.entries({
    Accept: "application/json",
    ...additionalHeaders,
    ...options.headers
  }).filter(([_, value]) => isDefined(value)).reduce((headers2, [key, value]) => ({
    ...headers2,
    [key]: String(value)
  }), {});
  if (isStringWithValue(token)) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  if (isStringWithValue(username) && isStringWithValue(password)) {
    const credentials = base64(`${username}:${password}`);
    headers["Authorization"] = `Basic ${credentials}`;
  }
  if (options.body) {
    if (options.mediaType) {
      headers["Content-Type"] = options.mediaType;
    } else if (isBlob(options.body)) {
      headers["Content-Type"] = options.body.type || "application/octet-stream";
    } else if (isString(options.body)) {
      headers["Content-Type"] = "text/plain";
    } else if (!isFormData(options.body)) {
      headers["Content-Type"] = "application/json";
    }
  }
  return new Headers(headers);
};
var getRequestBody = (options) => {
  if (options.body !== void 0) {
    if (options.mediaType?.includes("/json")) {
      return JSON.stringify(options.body);
    } else if (isString(options.body) || isBlob(options.body) || isFormData(options.body)) {
      return options.body;
    } else {
      return JSON.stringify(options.body);
    }
  }
  return void 0;
};
var sendRequest = async (config, options, url, body, formData, headers, onCancel) => {
  const controller = new AbortController();
  const request2 = {
    headers,
    body: body ?? formData,
    method: options.method,
    signal: controller.signal
  };
  if (config.WITH_CREDENTIALS) {
    request2.credentials = config.CREDENTIALS;
  }
  onCancel(() => controller.abort());
  return await fetch(url, request2);
};
var getResponseHeader = (response, responseHeader) => {
  if (responseHeader) {
    const content = response.headers.get(responseHeader);
    if (isString(content)) {
      return content;
    }
  }
  return void 0;
};
var getResponseBody = async (response) => {
  if (response.status !== 204) {
    try {
      const contentType = response.headers.get("Content-Type");
      if (contentType) {
        const jsonTypes = ["application/json", "application/problem+json"];
        const isJSON = jsonTypes.some((type) => contentType.toLowerCase().startsWith(type));
        if (isJSON) {
          return await response.json();
        } else {
          return await response.text();
        }
      }
    } catch (error) {
      console.error(error);
    }
  }
  return void 0;
};
var catchErrorCodes = (options, result) => {
  const errors = {
    400: "Bad Request",
    401: "Unauthorized",
    403: "Forbidden",
    404: "Not Found",
    500: "Internal Server Error",
    502: "Bad Gateway",
    503: "Service Unavailable",
    ...options.errors
  };
  const error = errors[result.status];
  if (error) {
    throw new ApiError(options, result, error);
  }
  if (!result.ok) {
    const errorStatus = result.status ?? "unknown";
    const errorStatusText = result.statusText ?? "unknown";
    const errorBody = (() => {
      try {
        return JSON.stringify(result.body, null, 2);
      } catch (e) {
        return void 0;
      }
    })();
    throw new ApiError(
      options,
      result,
      `Generic Error: status: ${errorStatus}; status text: ${errorStatusText}; body: ${errorBody}`
    );
  }
};
var request = (config, options) => {
  return new CancelablePromise(async (resolve2, reject, onCancel) => {
    try {
      const url = getUrl(config, options);
      const formData = getFormData(options);
      const body = getRequestBody(options);
      const headers = await getHeaders(config, options);
      if (!onCancel.isCancelled) {
        const response = await sendRequest(config, options, url, body, formData, headers, onCancel);
        const responseBody = await getResponseBody(response);
        const responseHeader = getResponseHeader(response, options.responseHeader);
        const result = {
          url,
          ok: response.ok,
          status: response.status,
          statusText: response.statusText,
          body: responseHeader ?? responseBody
        };
        catchErrorCodes(options, result);
        resolve2(result.body);
      }
    } catch (error) {
      reject(error);
    }
  });
};

// ../services/generated/auth-service/services/WhoopAuthResourceV2Service.ts
var WhoopAuthResourceV2Service = class {
  /**
   * Change password using the current password and a new password
   * @returns any Successfully changed password
   * @throws ApiError
   */
  static changePassword({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "PUT",
      url: "/v2/whoop/change-password",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Malformed header`,
        401: `Stale access_token`,
        403: `Bad current password`,
        422: `New password too short or matches current password`,
        500: `Server error`
      }
    });
  }
  /**
   * Internal endpoint. Create a reset_password_token on behalf of an account.
   * @returns any Reset token generated successfully
   * @throws ApiError
   */
  static createResetPasswordToken({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/v2/whoop/reset-password/token",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Malformed request or header`,
        500: `Server error`
      }
    });
  }
  /**
   * A user can sign-out of all devices here.
   * @returns any Success
   * @throws ApiError
   */
  static deleteAllTokensForSelf({
    apiToken
  }) {
    return request(OpenAPI, {
      method: "DELETE",
      url: "/v2/whoop/tokens",
      headers: {
        "API-TOKEN": apiToken
      },
      errors: {
        400: `Malformed request or header`,
        403: `A backend service tried to call this endpoint, use /nuke instead`,
        500: `Server error`
      }
    });
  }
  /**
   * @returns any default response
   * @throws ApiError
   */
  static disableAccount() {
    return request(OpenAPI, {
      method: "DELETE",
      url: "/v2/whoop/account"
    });
  }
  /**
   * Internal Only - Generate V2 Password Hash
   * Used by api-server to populate v2 hash. This will be deleted after Secure the Front Door part 2 is rolled out.
   * @returns any Successfully invalidated the refresh token
   * @throws ApiError
   */
  static hashPassword({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/v2/whoop/password/hash",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Malformed header`,
        500: `Server error`
      }
    });
  }
  /**
   * @returns Account default response
   * @throws ApiError
   */
  static integrationTestSignUp({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/v2/whoop/sign-up",
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Internal Only - Revoke tokens
   * You must always provide the userId query param. The token and type query params are optional. If you submit only the userId, all tokens will be revoked. If you submit the userId and tokenType, all tokens of that type for the user will be revoked. If you submit the userId, token, and tokenType that specific token will be revoked. You may not submit a token without a tokenType.
   * @returns any Successfully revoked token(s)
   * @throws ApiError
   */
  static nukeTokens({
    type,
    token
  }) {
    return request(OpenAPI, {
      method: "DELETE",
      url: "/v2/whoop/nuke",
      query: {
        "type": type,
        "token": token
      },
      errors: {
        400: `Token string provided without token type`,
        401: `Bad auth header, this endpoint does not accept bearer tokens`,
        403: `Token not owned by provided userId`,
        404: `Token+TokenType does not exist`,
        500: `Server error`
      }
    });
  }
  /**
   * Refresh WHOOP token set
   * @returns any Successfully refreshed
   * @throws ApiError
   */
  static refresh({
    authorization
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/v2/whoop/refresh",
      headers: {
        "Authorization": authorization
      },
      errors: {
        400: `Malformed header`,
        401: `Consumed or expired refresh token supplied`,
        500: `Server error`
      }
    });
  }
  /**
   * Consume a reset-password token to update an account's password
   * @returns any Password updated successfully
   * @throws ApiError
   */
  static resetPassword1({
    authorization,
    requestBody
  }) {
    return request(OpenAPI, {
      method: "PUT",
      url: "/v2/whoop/reset-password",
      headers: {
        "Authorization": authorization
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Malformed request or header`,
        500: `Server error`
      }
    });
  }
  /**
   * Request a reset-password email to be sent to the supplied email
   * @returns any If the account does exist, an email was successfully sent
   * @throws ApiError
   */
  static sendResetPasswordEmail({
    v2 = false,
    requestBody
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/v2/whoop/forgot-password",
      query: {
        "v2": v2
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Malformed request`,
        500: `Server error`
      }
    });
  }
  /**
   * Sign-in to the WHOOP App
   * @returns any Successfully signed in
   * @throws ApiError
   */
  static signIn({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/v2/whoop/sign-in",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Malformed request`,
        401: `Username and Password combination is incorrect`,
        500: `Server error`
      }
    });
  }
  /**
   * Sign-out of WHOOP by invalidating the refresh token
   * Clients should also delete all locally stored credentials
   * @returns any Successfully invalidated the refresh token
   * @throws ApiError
   */
  static signOut({
    authorization
  }) {
    return request(OpenAPI, {
      method: "DELETE",
      url: "/v2/whoop/sign-out",
      headers: {
        "Authorization": authorization
      },
      errors: {
        400: `Malformed header`,
        401: `Stale refresh_token`,
        500: `Server error`
      }
    });
  }
};

// ../services/generated/auth-service/services/WhoopUsersResourceV2Service.ts
var WhoopUsersResourceV2Service = class {
  /**
   * @returns UserResponse default response
   * @throws ApiError
   */
  static getUser1() {
    return request(OpenAPI, {
      method: "GET",
      url: "/v2/user"
    });
  }
  /**
   * @returns any default response
   * @throws ApiError
   */
  static updateUser1({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "PUT",
      url: "/v2/user",
      body: requestBody,
      mediaType: "application/json"
    });
  }
};

// src/client.ts
var Cookies = __toESM(require("es-cookie"));
var import_analytics_next = require("@segment/analytics-next");
var WHOOP_AUTH_TOKEN = `whoop-auth-token`;
var WHOOP_AUTH_COOKIE_FROM_STORAGE = "whoop.security.accessToken";
var WHOOP_REFRESH_TOKEN = `whoop-auth-refresh-token`;
var WHOOP_AUTH_EXPIRY = `whoop-auth-expiry`;
var WHOOP_AUTH_USER = `whoop-auth-user`;
var WHOOP_LEGACY_IOS_COOKIE = `@whoopauth.accessToken`;
var WHOOP_ENCODED_LEGACY_IOS_COOKIE = `%40whoopauth.accessToken`;
var WHOOP_LEGACY_IOS_EXPIRY = `@whoopauth.accessToken.expires`;
var WHOOP_ENCODED_LEGACY_IOS_EXPIRY = `%40whoopauth.accessToken.expires`;
var ClientAuth = class {
  #now = /* @__PURE__ */ new Date();
  #authenticated = false;
  #token = "";
  #tokenExpiresAt = this.#now;
  // instantiate to expire right away
  #refreshToken = "";
  #refreshTokenExpiresAt = this.#now;
  // instantiate to expire right away
  segmentAnalytics = null;
  #apiEnv = "prod";
  ONE_HOUR = 60 * 60 * 1e3;
  #isRefreshing = false;
  constructor({ env, segmentKey }) {
    const apiEnv = env === "prod" ? "prod" : "dev";
    this.#apiEnv = apiEnv;
    OpenAPI.BASE = `https://api.${apiEnv}.whoop.com/auth-service`;
    this.loadAuthenticationData();
    if (this.isClientSide()) {
      this.initSegment(segmentKey);
    }
  }
  async initSegment(segmentKey) {
    this.segmentAnalytics = new import_analytics_next.AnalyticsBrowser();
    this.segmentAnalytics.load({
      writeKey: segmentKey
    }).catch((error) => {
      console.error("There was a problem initiating segment", error);
    });
  }
  isClientSide() {
    return typeof window !== "undefined";
  }
  getToken() {
    return this.#token;
  }
  async getUser() {
    OpenAPI.BASE = `https://api.${this.#apiEnv}.whoop.com/auth-service`;
    OpenAPI.HEADERS = {
      Authorization: `Bearer ${this.#token}`
    };
    let userResponse;
    try {
      userResponse = await WhoopUsersResourceV2Service.getUser1();
    } catch (e) {
    }
    return userResponse?.user;
  }
  trackEvent({ eventName, category, action }) {
    this.segmentAnalytics?.track(eventName, { category, action });
  }
  isAuthenticated() {
    return this.#authenticated;
  }
  cleanCookie = (cookie) => {
    const decodedToken = decodeURIComponent(cookie)?.replaceAll('"', "");
    try {
      const parsedToken = JSON.parse(decodedToken);
      return parsedToken;
    } catch (_error) {
      return decodedToken;
    }
  };
  loadLegacyToken() {
    const legacyToken = Cookies.get(WHOOP_LEGACY_IOS_COOKIE) ?? Cookies.get(WHOOP_ENCODED_LEGACY_IOS_COOKIE) ?? "";
    const legacyExpiry = Cookies.get(WHOOP_LEGACY_IOS_EXPIRY) ?? Cookies.get(WHOOP_ENCODED_LEGACY_IOS_EXPIRY) ?? "";
    if (legacyToken && legacyExpiry) {
      this.#token = this.cleanCookie(legacyToken);
      this.#tokenExpiresAt = new Date(this.cleanCookie(legacyExpiry));
      this.#authenticated = true;
      Cookies.remove(WHOOP_LEGACY_IOS_COOKIE);
      Cookies.remove(WHOOP_ENCODED_LEGACY_IOS_COOKIE);
      Cookies.set(WHOOP_AUTH_TOKEN, this.#token, {
        expires: this.#tokenExpiresAt,
        secure: false
      });
      Cookies.remove(WHOOP_LEGACY_IOS_EXPIRY);
      Cookies.remove(WHOOP_ENCODED_LEGACY_IOS_EXPIRY);
      Cookies.set(WHOOP_AUTH_EXPIRY, this.#tokenExpiresAt.toString(), {
        expires: this.#tokenExpiresAt,
        secure: false
      });
    }
  }
  async loadAuthenticationData() {
    if (!this.#authenticated && this.isClientSide()) {
      const authToken = Cookies.get(WHOOP_AUTH_TOKEN) || Cookies.get(WHOOP_AUTH_COOKIE_FROM_STORAGE);
      this.#token = authToken ? this.cleanCookie(authToken) : "";
      if (!this.#token) {
        this.loadLegacyToken();
      }
      this.#refreshToken = Cookies.get(WHOOP_REFRESH_TOKEN) ?? "";
      this.#authenticated = this.#token.length > 0;
      if (this.#refreshToken && (this.isExpired() || this.isAboutToExpire())) {
        await this.refresh();
      }
    }
  }
  isExpired() {
    return this.#token === "";
  }
  isRefreshing() {
    return this.#isRefreshing;
  }
  isAboutToExpire() {
    const authExpiry = Cookies.get(WHOOP_AUTH_EXPIRY);
    if (authExpiry) {
      const expiresWithinHour = new Date(authExpiry).valueOf() - Date.now() < this.ONE_HOUR;
      return this.isAuthenticated() && expiresWithinHour;
    }
    return false;
  }
  setData(data) {
    this.#token = data.access_token ?? "";
    this.#refreshToken = data.refresh_token ?? "";
    this.#tokenExpiresAt = new Date(
      Date.now() + (data.access_token_expires_in ?? 0) * 1e3
    );
    this.#refreshTokenExpiresAt = new Date(
      Date.now() + (data.refresh_token_expires_in ?? 0) * 1e3
    );
    if (this.#token.length > 0) {
      this.#authenticated = true;
    }
  }
  setCookies() {
    Cookies.set(WHOOP_AUTH_TOKEN, this.#token, {
      expires: this.#tokenExpiresAt,
      secure: false
    });
    Cookies.set(WHOOP_AUTH_EXPIRY, this.#tokenExpiresAt.toString(), {
      expires: this.#tokenExpiresAt,
      secure: false
    });
    Cookies.set(WHOOP_REFRESH_TOKEN, this.#refreshToken, {
      expires: this.#refreshTokenExpiresAt,
      secure: false
    });
  }
  clearCookies() {
    Cookies.remove(WHOOP_AUTH_TOKEN);
    Cookies.remove(WHOOP_REFRESH_TOKEN);
    Cookies.remove(WHOOP_AUTH_EXPIRY);
    Cookies.remove(WHOOP_AUTH_USER);
    this.#token = "";
    this.#refreshToken = "";
    this.#authenticated = false;
  }
  trackSignInPageView() {
    this.segmentAnalytics?.track("Auth Flow", {
      category: "sign_in_web_page",
      action: "viewed"
    });
  }
  async signIn({ username, password }) {
    this.segmentAnalytics?.track("Auth Flow", {
      category: "sign_in_web_page",
      action: "sign_in"
    });
    try {
      const data = await WhoopAuthResourceV2Service.signIn({
        requestBody: { username, password }
      });
      this.setData(data);
      this.setCookies();
    } catch (_error) {
      const error = _error;
      if (error && error.message) {
        if (error.message.includes("401")) {
          this.refresh();
        } else {
          this.segmentAnalytics?.track("Auth Flow", {
            category: "sign_in_web_page",
            action: "invalid_signin"
          });
          throw Error(`Failed to sign in: ${error.message}`);
        }
      }
    }
  }
  async refresh() {
    if (!this.#refreshToken) return;
    try {
      this.#isRefreshing = true;
      const data = await WhoopAuthResourceV2Service.refresh({
        authorization: `Bearer ${this.#refreshToken}`
      });
      this.setData(data);
      this.setCookies();
      this.#isRefreshing = false;
    } catch (_error) {
      this.#isRefreshing = false;
      const error = _error;
      if (error && error.message) {
        if (error.message.includes("401")) {
          this.clearCookies();
        } else {
          console.error("Error while refreshing token", error);
        }
      }
    }
  }
  async signOut() {
    this.clearCookies();
    try {
      await WhoopAuthResourceV2Service.signOut({
        authorization: `Bearer ${this.#refreshToken}`
      });
    } catch (error) {
      console.error("There was a problem signing out", error);
    }
  }
  async resetPassword({
    resetToken,
    newPassword
  }) {
    const body = {
      new_password: newPassword
    };
    await WhoopAuthResourceV2Service.resetPassword1({
      authorization: `Bearer ${resetToken}`,
      requestBody: body
    });
  }
  async sendPasswordEmail({
    email,
    useV2 = false
  }) {
    await WhoopAuthResourceV2Service.sendResetPasswordEmail({
      requestBody: { email },
      v2: useV2
    });
  }
};
var clientInstance = null;
var createAuth = ({ env, segmentKey }) => {
  if (!clientInstance) {
    clientInstance = new ClientAuth({ env, segmentKey });
  }
  return clientInstance;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  WHOOP_AUTH_EXPIRY,
  WHOOP_AUTH_TOKEN,
  WHOOP_AUTH_USER,
  WHOOP_ENCODED_LEGACY_IOS_COOKIE,
  WHOOP_LEGACY_IOS_COOKIE,
  WHOOP_LEGACY_IOS_EXPIRY,
  WHOOP_REFRESH_TOKEN,
  createClientAuth
});
//# sourceMappingURL=index.js.map